import queryString from 'query-string';

const TRAFFIC_STORAGE_KEY = 'trafficInfo';

const PAID_UTM_MEDIUMS = [
  'cpc',
  'ppc',
  'paid',
  'paidsearch',
  'display',
  'cpm',
  'cpv',
  'cpa',
  'retargeting',
  'paid-social',
];

function getSearchParams() {
  const iframeParams = queryString.parse(window.location.search);

  try {
    if (window.parent && window.parent !== window) {
      const parentParams = queryString.parse(window.parent.location.search);
      return { ...parentParams, ...iframeParams };
    }
  } catch (e) {
    // Cross-origin parent; fall back to iframe URL params only.
  }

  return iframeParams;
}

function getTrafficType(params) {
  if (params.gclid || params.msclkid) {
    return 'paid';
  }

  const medium = (params.utm_medium || '').toLowerCase();
  if (PAID_UTM_MEDIUMS.includes(medium)) {
    return 'paid';
  }

  return 'organic';
}

function hasPaidSignals(params) {
  return getTrafficType(params) === 'paid';
}

export function captureTrafficAttribution() {
  const params = getSearchParams();
  const storedInfo = sessionStorage.getItem(TRAFFIC_STORAGE_KEY);
  const storedType = storedInfo ? JSON.parse(storedInfo).traffic_type : null;
  const incomingType = getTrafficType(params);
  const traffic_type = storedType === 'paid' || incomingType === 'paid' ? 'paid' : 'organic';
  const trafficInfo = { traffic_type };

  sessionStorage.setItem(TRAFFIC_STORAGE_KEY, JSON.stringify(trafficInfo));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'traffic_attribution_captured',
    traffic_type,
  });

  return trafficInfo;
}

export function getTrafficFields() {
  const storedInfo = sessionStorage.getItem(TRAFFIC_STORAGE_KEY);

  if (storedInfo) {
    return JSON.parse(storedInfo);
  }

  return captureTrafficAttribution();
}
